/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

type CustomerAddressUpdateProps = PageProps;

const CustomerAddressUpdateValidationPage: React.FC<CustomerAddressUpdateProps> = ({ id }) => {
    return (
        <Page data-test-selector="CustomerAddressUpdateValidation">
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const CustomerAddressUpdateValidationModule: PageModule = {
    component: CustomerAddressUpdateValidationPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default CustomerAddressUpdateValidationModule;

